'use client'
import React from 'react'
import styled from 'styled-components'

import BreadCrumbs from '../../sections/breadcrumbs'
import SearchSite from '../../modules/searchSite'

const Wrapper = styled.div`
  padding: 42px 0;
`

const SearchPage = ({ breadcrumbs, sidelists, faq }) => {
  return (
    <>
      <Wrapper>
        <BreadCrumbs
          breadcrumbs={breadcrumbs}
          spacing={45}
          widthVariant="full"
        />
        <SearchSite
          perPage={8}
          placeholder="Zoeken"
          sidelists={sidelists}
          faqs={faq}
        />
      </Wrapper>
    </>
  )
}

export default SearchPage
